import Cookies from 'js-cookie';

const defaultAttributes = {
  path: '/',
  sameSite: 'None',
  secure: true
};
const TOKEN_NAME = 'staff_token';
// staff_token 内存缓存：生产环境不碰后端 domain cookie，仅 localhost 写 fallback
let t = '';

const isLocalhost = function () {
  return location.hostname === 'localhost';
};

const getAttributes = function (attributes) {
  return Object.assign({}, defaultAttributes, attributes);
};

const cookie = {
  set: function (name, value, attributes) {
    if (name === TOKEN_NAME) {
      t = value;
      // 非 localhost 由后端独占 domain cookie，前端只保留内存
      if (!isLocalhost()) return;
    }
    Cookies.set(name, value, getAttributes(attributes));
  },
  get: function (name) {
    if (name !== TOKEN_NAME) return Cookies.get(name);
    // 仅 localhost 从 cookie 回填，生产完全依赖内存（Token 握手写入）
    if (!t && isLocalhost()) t = Cookies.get(name) || '';
    return t;
  },
  remove: function (name, attributes) {
    if (name === TOKEN_NAME) {
      t = '';
      // 非 localhost 的 domain cookie 由 SSO logout 清理，前端不删
      if (!isLocalhost()) return;
    }
    Cookies.remove(name, getAttributes(attributes));
  }
};

export default cookie;
